import { client } from '../../../actions';
import { authHeader } from '../../../helpers/auth-header';

export const getExpiredDocsCount = async (query) => {
  let url = '/Docs/expired_count';
  if (query) {
    url = `${url}?${query}`;
  }
  const response = await client.get(url, {
    headers: authHeader(),
  });
  return response.data;
};
